import { render, staticRenderFns } from "./addPurchaseCategory.vue?vue&type=template&id=34a2ce38&scoped=true"
import script from "./addPurchaseCategory.vue?vue&type=script&lang=js"
export * from "./addPurchaseCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a2ce38",
  null
  
)

export default component.exports